export const getHeaderKey = colId => `table-header-${colId}`
export const getColumnKey = colId => `table-col-${colId}`
export const getRowKey = rowId => `table-row-${rowId}`
export const getCellKey = (rowId, colId) => `table-cell-${rowId}-${colId}`
